import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  MdOutlineCorporateFare,
  MdManageAccounts,
} from 'react-icons/md';
import { RiMentalHealthFill } from 'react-icons/ri';
import { HiUserGroup } from 'react-icons/hi';
import { GiHypodermicTest } from 'react-icons/gi';
import { PanelRightClose, PanelRightOpen, ShieldUser } from 'lucide-react';
import arrow from '../../../images/Sidebar/arrow.svg';

// const filterItems = (items) => {
//   return items
//     .map(item => {
//       // Skip items with pageId: 0
//       if (item.pageId === 0) return null;
      
//       if (item.subItems) {
//         const filteredSubItems = filterItems(item.subItems);
//         return filteredSubItems.length > 0 ? { ...item, subItems: filteredSubItems } : null;
//       }
//       return !item.pageId || userPermission.includes(item.pageId) ? item : null;
//     })
//     .filter(Boolean); // remove nulls
// };

const sidebarItems = [
  {
    type: 'link',
    to: '/admin/admin_user/corporate',
    icon: MdOutlineCorporateFare,
    text: 'Corporate',
    pageId: 1,
  },
  {
    type: 'link',
    to: '/admin/admin_user/hr',
    icon: MdManageAccounts,
    text: 'Admin',
    pageId: 8,
  },
  {
    type: 'menu',
    icon: HiUserGroup,
    text: 'Member',
    paths: [
      '/admin/admin_user/uploadeemployee',
      '/admin/admin_user/employee',
      '/admin/export',
      '/admin/admin_user/family_member',
    ],
    subItems: [
      { to: '/admin/admin_user/uploadeemployee', text: 'Create Member', pageId: 2 },
      { to: '/admin/admin_user/employee', text: 'Member List', pageId: 9 },
      { to: '/admin/export', text: 'Export', pageId: 3 },
      { to: '/admin/admin_user/family_member', text: 'Family Member', pageId: 10 },
    ],
  },
  {
    type: 'link',
    to: '/admin/admin_user/healthtips',
    icon: RiMentalHealthFill,
    text: 'Health Tips',
    pageId: 4,
  },
  {
    type: 'link',
    to: '/admin/admin_user/labtest',
    icon: GiHypodermicTest,
    text: 'Book A Lab Test',
    pageId: 11,
  },
  {
    type: 'menu',
    icon: HiUserGroup,
    text: 'Partners',
    paths: [
      '/admin/admin_user/master',
      '/admin/admin_user/vfs_uk',
      '/admin/admin_user/credit_note',
      '/admin/admin_user/payment_failed',
      '/admin/admin_user/bls',
      '/admin/admin_user/vfs_team_members',
    ],
    subItems: [
      { to: '/admin/admin_user/bls', text: 'BLS', pageId: 5 },
      { to: '/admin/admin_user/master', text: 'Onevasco', pageId: 12 },
      {
        type: 'submenu',
        text: 'VFS UK LP',
        paths: [
          '/admin/admin_user/vfs_uk',
          '/admin/admin_user/credit_note',
          '/admin/admin_user/payment_failed',
          '/admin/admin_user/vfs_team_members',
        ],
        subItems: [
          { to: '/admin/admin_user/vfs_uk', text: 'Members', pageId: 6 },
          { to: '/admin/admin_user/credit_note', text: 'Refund', pageId: 13 },
          { to: '/admin/admin_user/payment_failed', text: 'Payment Failed',pageId: 14 }, 
          { to: '/admin/admin_user/vfs_team_members', text: 'Team Members', pageId: 7 },
        ],
      },
    ],
  },
  {
    type: 'link',
    to: '/admin/admin_user/team_members',
    icon: ShieldUser,
    text: 'Team Members',
    pageId: 0,
  },
];


// const filteredSidebarItems = filterItems(sidebarItems);
const SidebarLink = ({ to, icon: Icon, text, collapsed }) => {
  return (
    <li>
      <NavLink
        to={to}
        className={({ isActive }) =>
          `
            group relative flex items-center gap-3 px-3 py-2 font-Roboto text-base rounded-lg
            transition-all duration-300
            ${
              isActive
                ? collapsed
                  ? 'bg-[#FCDD00] text-black rounded-full w-[50px] h-[50px] flex items-center justify-center'
                  : 'bg-[#FCDD00] text-black'
                : collapsed
                ? 'text-[#1A1A1A] rounded-full w-[50px] h-[50px] flex items-center justify-center hover:bg-gray-100'
                : 'text-[#1A1A1A] hover:bg-gray-100'
            }
          `
        }
      >
        <span className="text-xl">
          <Icon />
        </span>
        {!collapsed && text}
        {collapsed && (
          <span
            className="fixed left-[80px] rounded-md bg-black text-white text-sm px-2 py-1
                      opacity-0 group-hover:opacity-100 whitespace-nowrap z-[9999] pointer-events-none"
          >
            <div className="absolute top-1/2 translate-y-[-50%] -left-1 w-2 h-2 bg-black transform rotate-45"></div>
            {text}
          </span>
        )}
      </NavLink>
    </li>
  );
};

const SubMenu = ({ icon: Icon, text, paths, subItems, collapsed, setCollapsed }) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [showFloatingMenu, setShowFloatingMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const menuRef = React.useRef(null);

  useEffect(() => {
    setIsOpen(paths.some(subPath => location.pathname.startsWith(subPath)));
  }, [location.pathname, paths]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (collapsed) {
      setCollapsed(false);
    }
  };

  const handleMouseEnter = () => {
    if (collapsed && menuRef.current) {
      const rect = menuRef.current.getBoundingClientRect();
      setMenuPosition({
        top: rect.top,
        left: 80,
      });
      setShowFloatingMenu(true);
    }
  };

  const handleMouseLeave = () => {
    if (collapsed) {
      setShowFloatingMenu(false);
    }
  };

  return (
    <li ref={menuRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div
        onClick={handleToggle}
        className={`relative flex justify-between items-center px-3 py-2 cursor-pointer group rounded-lg
          ${(collapsed || !isOpen) && paths.some(subPath => location.pathname.startsWith(subPath)) 
            ? 'bg-[#FCDD00] text-black' 
            : 'text-[#1A1A1A] hover:bg-gray-100'}
          ${collapsed ? 'rounded-full w-[50px] h-[50px] flex items-center justify-center' : ''}
        `}
      >
        <div className={`flex gap-3 items-center ${collapsed ? 'my-1' : ''}`}>
          {Icon && <span><Icon /></span>}
          {!collapsed && <span className="font-Roboto text-base text-[#1A1A1A]">{text}</span>}
        </div>
        {!collapsed && (
          <img
            src={arrow}
            alt="arrow"
            className={`${isOpen ? 'rotate-180' : ''}`}
          />
        )}
      </div>

      {/* Expanded submenu (when sidebar is open) */}
      {!collapsed && isOpen && (
        <div className="pl-[22px]">
          {subItems.map((item, index) =>
            item.type === 'submenu' ? (
              <SubMenu key={index} {...item} collapsed={collapsed} setCollapsed={setCollapsed} />
            ) : (
              <NavLink
                key={index}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center font-Roboto text-base py-2 px-3
                  ${isActive ? 'bg-[#FCDD00] text-black rounded-lg p-3' : 'text-[#1A1A1A]'}`}
              >
                {item.text}
              </NavLink>
            )
          )}
        </div>
      )}

      {/* Floating submenu when collapsed */}
{collapsed && showFloatingMenu && (
  <div
    className="fixed z-50 py-2 bg-white rounded-md shadow-lg w-44"
    style={{ top: `${menuPosition.top}px`, left: `${menuPosition.left}px` }}
  >
    {subItems.map((item, index) =>
      item.type === 'submenu' ? (
        <div key={index} className="relative group">
          {/* Parent submenu item (VFS UK LP) */}
          <div className="flex items-center justify-between px-3 py-2 font-Roboto text-base text-[#1A1A1A] hover:bg-gray-100 cursor-pointer">
            <span>{item.text}</span>
            <img
              src={arrow}
              alt="arrow"
              className="w-3 h-3 transition-transform transform rotate-0 group-hover:-rotate-90"
            />
          </div>

          {/* Sub-floating menu for submenu items */}
          <div className="absolute z-50 hidden bg-white rounded-md shadow-lg -top-14 left-full w-44 2xl:top-0 group-hover:block">
            {item.subItems.map((sub, subIndex) => (
              <NavLink
                key={subIndex}
                to={sub.to}
                className={({ isActive }) =>
                  `block px-3 py-2 font-Roboto text-base ${
                    isActive
                      ? 'bg-[#FCDD00] text-black'
                      : 'text-[#1A1A1A] hover:bg-gray-100'
                  }`
                }
              >
                {sub.text}
              </NavLink>
            ))}
          </div>
        </div>
      ) : (
        <NavLink
          key={index}
          to={item.to}
          className={({ isActive }) =>
            `flex items-center font-Roboto text-base py-2 px-3
            ${isActive ? 'bg-[#FCDD00] text-black' : 'text-[#1A1A1A] hover:bg-gray-100'}`
          }
        >
          {item.text}
        </NavLink>
      )
    )}
  </div>
)}

    </li>
  );
};


const AdminSideBar = ({ collapsed, setCollapsed }) => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    // This will run on component mount and when localStorage changes
    const token = localStorage.getItem("Admin");
    if (token) {
      try {
        const parsedData = JSON.parse(token);
        setUserData(parsedData);
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }
  }, []);

  const userRole = userData?.data?.role;
  const userPermission = userData?.data?.permission || [];
  
  const filterItems = (items) => {
    return items
      .map(item => {
        // Skip items with pageId: 0
        if (item.pageId === 0) return null;
        
        if (item.subItems) {
          const filteredSubItems = filterItems(item.subItems);
          return filteredSubItems.length > 0 ? { ...item, subItems: filteredSubItems } : null;
        }
        return !item.pageId || userPermission.includes(item.pageId) ? item : null;
      })
      .filter(Boolean); // remove nulls
  };
  
  const filteredSidebarItems = filterItems(sidebarItems);

  return (
    <div
      className={`flex flex-col transition-all duration-300 bg-white
        ${
          collapsed
            ? "overflow-hidden justify-center w-[80px]"
            : "justify-between w-[240px]"
        }`}
    >
      <div className="min-w-[230px] bg-white flex-col justify-between flex">
        <div className="relative flex flex-col justify-center gap-2 px-3 py-3 text-xl group">
          <button
            onClick={() => setCollapsed((prevState) => !prevState)}
            className="text-[#1A1A1A] rounded-lg w-[50px] h-[50px] flex items-center justify-center hover:bg-gray-100"
          >
            {!collapsed && <PanelRightClose className="w-[20px] h-[20px]" />}
            {collapsed && <PanelRightOpen className="w-[20px] h-[20px]" />}
          </button>

          {/* Tooltip */}
          <span
            className="fixed left-[80px] rounded-md bg-black text-white text-sm px-2 py-1
                      opacity-0 group-hover:opacity-100 whitespace-nowrap z-[9999] pointer-events-none"
          >
            <div className="absolute top-1/2 translate-y-[-50%] -left-1 w-2 h-2 bg-black transform rotate-45"></div>
            {collapsed ? "Show" : "Hide"}
          </span>
        </div>
        <div>
          {userRole === "adaccountant" || userRole === "adsales" || userRole === "admanager" || userRole === "adsupport" ? (
            <ul className="px-3 pb-20 flex flex-col gap-2 w-[231px] text-xl">
              {filteredSidebarItems.map((item, index) =>
                item.type === "link" ? (
                  <SidebarLink key={index} {...item} collapsed={collapsed} />
                ) : (
                  <SubMenu
                    key={index}
                    {...item}
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                  />
                )
              )}
            </ul>
          ) : (
            <ul className="px-3 pb-20 flex flex-col gap-2 w-[231px] text-xl">
              {sidebarItems.map((item, index) =>
                item.type === "link" ? (
                  <SidebarLink key={index} {...item} collapsed={collapsed} />
                ) : (
                  <SubMenu
                    key={index}
                    {...item}
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                  />
                )
              )}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminSideBar;
